module.exports = __webpack_public_path__ + "static/kishore-nadhani-c69d9373e1de02494919511982c0f840.png";